exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".opacity0[data-v-82afa8b8]{opacity:0}.wrapper-name[data-v-82afa8b8]{display:flex;white-space:nowrap}.wrapper-name .name[data-v-82afa8b8]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
